import { CircularProgress, MenuItem, Select, SxProps } from "@mui/material";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { client } from "src/utils/axios-client";
import { SelectOption } from "src/types/common";

const loadOptions = (playbookId: string, activityIdentifer: string) => client.get(`/api/options/playbooks/cadencetemplates`, { params: { playbookId, activityIdentifer } }).then((res) => res.data);


type Props = {
    playbookId: string,
    activityIdentifer: string,
    value: string,
    error?: boolean,
    onChange: (newValue: string) => void,
    sx?: SxProps
}

const PlaybookCadenceTemplateDropdown = ({ playbookId, activityIdentifer, value, onChange, error = false, sx }: Props) => {
    const { data, isLoading, isError, error: fetchError, refetch } = useQuery<SelectOption[]>({
        queryKey: ['cadenceTemplateOptions' + activityIdentifer],
        queryFn: () => loadOptions(playbookId, activityIdentifer)
    });

    useEffect(() => {
        refetch();
    }, [playbookId, activityIdentifer])

    return (
        <Select
            fullWidth
            error={error}
            size="small"
            value={value}
            sx={{ ...sx }}
            onChange={(e) => onChange(e.target.value)}
        >
            {isLoading && <CircularProgress size="small" />}
            {!isLoading && data && data.map((item) => (
                <MenuItem
                    key={item.value}
                    value={item.value}
                >
                    {item.name}
                </MenuItem>
            ))}
        </Select>
    )
}

export default PlaybookCadenceTemplateDropdown;